import React from "react";
import { useOrg } from "@/hooks/useOrg";
import { useCurrentCohortYear } from "@/hooks/useCurrentCohortYear";
import { PredictiveModelWrapper } from "./PredictiveModelWrapper";
import { PredictiveModelType } from "./types";

interface PredictiveModelPageProps {
  modelType?: PredictiveModelType;
}

export const PredictiveModelPage: React.FC<PredictiveModelPageProps> = ({
  modelType = "Commit",
}) => {
  const { org, loading: orgIdLoading, error: orgIdError } = useOrg();
  const {
    cohortYear,
    loading: cohortLoading,
    error: cohortError,
  } = useCurrentCohortYear();

  return (
    <PredictiveModelWrapper
      orgId={org?.id}
      orgIdLoading={orgIdLoading}
      orgIdError={orgIdError}
      cohortYear={cohortYear}
      cohortLoading={cohortLoading}
      cohortError={cohortError}
      modelType={modelType}
    />
  );
};
